<template>
  <div>
    <v-row>
      <v-subheader style="float: left; line-height: 30px; display: table; font-size: 16px" v-if="labelLeft">
        {{ $t('date') + ' ' + label }}</v-subheader>
    </v-row>
    <v-row>
      <v-col style="padding-top: 24px;">
        <v-text-field :class="classe" v-model="formatDate"
          :label="label && !labelLeft ? (manageTime ? $t('date') + ' ' + label : label) : null" v-mask="mask"
          placeholder="GG/MM/AAAA" :hint="hint" :dense="dense" :clearable="readOnly" :readonly="readOnly"
          :disabled="disabled" :persistent-hint="persistentHint" @blur="emitSelectedText"
          :outlined="outlined ? outlined : false" @click:prepend="openPicker"
          :prepend-icon="prependIcon ? prependIcon : 'mdi-calendar-blank'" :rules="rules">
        </v-text-field>
      </v-col>
      <v-col style="padding-top: 24px;" v-if="manageTime">
        <my-timepicker :class="classe" :label="label && !labelLeft ? label : null" v-model="pickerDateTime" :dense="dense"
          :required="required" :readonly="readOnly" :disabled="disabled" :persistent-hint="persistentHint"
          :outlined="outlined ? outlined : false" />
      </v-col>
      <v-dialog ref="dialog" v-model="modal" persistent width="290px">
        <template> </template>

        <v-date-picker locale="IT" v-model="selectedDate" scrollable @input="emitSelectedPicker">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> {{ $t('undo') }}</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import moment from "moment";
import MyTimepicker from "@/components/base/MyTimepicker.vue";

export default {
  name: "my-datepicker",
  directives: {
    mask,
  },
  components: {
    MyTimepicker,
  },
  props: {
    label: null,
    labelLeft: false,
    value: null,
    prependIcon: null,
    outlined: null,
    hint: null,
    persistentHint: false,
    required: false,
    disabled: false,
    dense: false,
    manageTime: false,
    classe: null,
  },
  data() {
    return {
      mask: "##/##/####",
      modal: false,
      ore: 0,
      minuti: 0,
      secondi: 0,
      readOnly: false,
      selectedDate: null,
      formatDate: null,
      focus: null,
      pickerDateTime: null,
      rules: [
        (value) => (this.required ? !!value || "Required." : true),
        // (value) => {
        //   return (
        //     moment(this.formatDate, "DD/MM/YYYY").isValid() ||
        //     this.$t("invalid_date")
        //   );
        // },
      ],
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      // watch it
      this.formatInitialDate();
    },
    pickerDateTime: function (newVal, oldVal) {
      // watch it
      this.$emit("input", new Date(newVal).toISOString());
    },
    formatDate: function (newVal, oldVal) {
      // watch it
      if (!newVal) {
        this.readOnly = false;
      }

    },
  },
  mounted() {
    this.formatInitialDate();
  },
  methods: {
    formatInitialDate() {
      if (this.value && this.value !== 'Invalid Date') {
        try {
          this.pickerDateTime = new Date(this.value)
          this.ore = new Date(this.value).getUTCHours();
          this.minuti = new Date(this.value).getUTCMinutes();
          this.secondi = new Date(this.value).getUTCSeconds();
          this.formatDate = moment(this.value, "YYYY-MM-DD").format("DD/MM/YYYY");
          this.readOnly = true;
        } catch (e) {
          this.formatDate = null;
          this.readOnly = false;
          this.ore = 0;
          this.minuti = 0;
          this.secondi = 0;
        }
      } else {
        this.formatDate = null;
        this.readOnly = false;
        this.ore = 0;
        this.minuti = 0;
        this.secondi = 0;
      }
      if (!this.manageTime) {
        this.ore = 0;
        this.minuti = 0;
        this.secondi = 0;
      }
    },
    openPicker() {
      let momentDate = moment(this.formatDate, "DD/MM/YYYY");
      if (momentDate.isValid())
        this.selectedDate = momentDate.format("YYYY-MM-DD");
      else this.selectedDate = moment().format("YYYY-MM-DD");
      this.modal = true;
    },
    emitSelectedPicker(elem) {
      this.modal = false;
      let dateTime = new Date(this.selectedDate);
      dateTime.setUTCHours(this.ore)
      dateTime.setUTCMinutes(this.minuti)
      dateTime.setUTCSeconds(this.secondi)
      this.pickerDateTime = dateTime;
      this.formatDate = moment(this.pickerDateTime, "YYYY-MM-DD").format("DD/MM/YYYY");

    },
    emitSelectedText(elem) {
      try {
        if (moment(this.formatDate, "DD/MM/YYYY").isValid()) {
          let datetime = moment.utc(this.formatDate, "DD/MM/YYYY");
          let newDate = new Date(datetime)
          newDate.setUTCHours(this.ore)
          newDate.setUTCMinutes(this.minuti)
          newDate.setUTCSeconds(this.secondi)
          this.pickerDateTime = newDate
        } else this.formatInitialDate();
      } catch (e) {
        this.formatInitialDate();
      }
      this.readOnly = true;
    },
  },
};
</script>